import React, { FC } from 'react';

import { Box } from '@chakra-ui/react';
import { customTheme } from 'theme';

import { FindingsTable } from 'containers/Findings/FindingsOverview/Components/AlertTables/Components/FindingsTable';

interface Props {
  onOpenLearnMore();
}

export const AllFindings: FC<Props> = props => {
  return (
    <Box
      p={5}
      bg={'#fff'}
      w={'full'}
      h={'full'}
      borderRadius={customTheme.radii.cardBorderRadius}
    >
      <FindingsTable title="Findings" onOpenLearnMore={props.onOpenLearnMore} />
    </Box>
  );
};
